import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './ShopsSearch.styles';
import { SearchIcon } from '@/components/UI/Icons/Icons';

export interface ShopsSearchProps {
  searchValue: string;
  onSearchChange?: (value: string) => void;
}

export const ShopsSearch: React.FC<ShopsSearchProps> = ({
  searchValue,
  onSearchChange,
}) => {
  const { t } = useTranslation();
  const [localSearch, setLocalSearch] = useState(searchValue);

  useEffect(() => {
    setLocalSearch(searchValue);
  }, [searchValue]);

  useEffect(() => {
    const handler = window.setTimeout(() => {
      const trimmed = localSearch.trim();
      onSearchChange?.(trimmed);
    }, 400);

    return () => window.clearTimeout(handler);
  }, [localSearch, onSearchChange]);

  return (
    <S.SearchWrapper>
      <S.SearchField>
        <S.SearchIconWrap>
          <SearchIcon width={18} height={18} />
        </S.SearchIconWrap>
        <S.SearchInput
          value={localSearch}
          placeholder={t('pages.shops.search_placeholder')}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setLocalSearch(e.target.value)
          }
        />
      </S.SearchField>
    </S.SearchWrapper>
  );
};
